import { graphql, useStaticQuery } from 'gatsby'
import { filterPageDataByLanguage } from '../../common/serviceHelpers'
import _get from 'lodash/get'

/* Kentico model: Form Section */
export interface KenticoFormSection extends KontentItem {
  header: KontentTextElement
  options_field: KontentTextElement
  name_field: KontentTextElement
  company_field: KontentTextElement
  email_field: KontentTextElement
  phone_field: KontentTextElement
  message_field: KontentTextElement
  save_button: KontentTextElement
  consent_desktop_first_line: KontentTextElement
  consent_desktop_rest_lines: KontentTextElement
  consent_mobile_first_line: KontentTextElement
  consent_mobile_rest_lines: KontentTextElement
  recaptcha_error_message: KontentTextElement
  success_message: KontentTextElement
  error_message: KontentTextElement
}

export interface Form {
  options: string
  nameFieldTitle: string
  companyFieldTitle: string
  emailFieldTitle: string
  phoneFieldTitle: string
  messageFieldTitle: string
  saveButtonTitle: string
  consentDesktopFirstLine: string
  consentDesktopRestLines: string
  consentMobileFirstLine: string
  consentMobileRestLines: string
  ReCAPTCHAErrorMessage: string
  successMessage: string
  errorMessage: string
}

export class FormSection implements Form {
  header: string
  options: string
  nameFieldTitle: string
  companyFieldTitle: string
  emailFieldTitle: string
  phoneFieldTitle: string
  messageFieldTitle: string
  saveButtonTitle: string
  consentDesktopFirstLine: string
  consentDesktopRestLines: string
  consentMobileFirstLine: string
  consentMobileRestLines: string
  ReCAPTCHAErrorMessage: string
  successMessage: string
  errorMessage: string

  constructor(data: KenticoFormSection) {
    this.header = _get(data, 'section_header.value', '')
    this.options = _get(data, 'inquiries_field.value', '')
    this.nameFieldTitle = _get(data, 'name_field.value', '')
    this.companyFieldTitle = _get(data, 'company_field.value', '')
    this.emailFieldTitle = _get(data, 'email_field.value', '')
    this.phoneFieldTitle = _get(data, 'phone_field.value', '')
    this.messageFieldTitle = _get(data, 'message_field.value', '')
    this.saveButtonTitle = _get(data, 'save_button.value', '')
    this.consentDesktopFirstLine = _get(data, 'consent_desktop_first_line.value', '')
    this.consentDesktopRestLines = _get(data, 'consent_desktop_rest_lines.value', '')
    this.consentMobileFirstLine = _get(data, 'consent_mobile_first_line.value', '')
    this.consentMobileRestLines = _get(data, 'consent_mobile_rest_lines.value', '')
    this.ReCAPTCHAErrorMessage = _get(data, 'recaptcha_error_message.value', '')
    this.successMessage = _get(data, 'success_message.value', '')
    this.errorMessage = _get(data, 'error_message.value', '')
  }
}

const formSectionFragment = graphql`
query FormSectionQuery {
  allKontentItemPage {
    nodes {
      elements {
        content {
          value {
            ... on kontent_item_form_section {
              elements {
                ...kontent_item_form_section_elementsFragment
              }
              preferred_language
              system {
                codename
              }
            }
          }
        }
      }
      system {
        codename
      }
    }
  }
}`

export const formSectionElementsFragment = graphql`
  fragment kontent_item_form_section_elementsFragment on kontent_item_form_section_elements {
    section_header {
      value
    }
    inquiries_field {
      value
    }
    name_field {
      value
    }
    company_field {
      value
    }
    email_field {
      value
    }
    phone_field {
      value
    }
    message_field {
      value
    }
    save_button {
      value
    }
    consent_desktop_first_line {
      value
    }
    consent_desktop_rest_lines {
      value
    }
    consent_mobile_first_line {
      value
    }
    consent_mobile_rest_lines {
      value
    }
    recaptcha_error_message {
      value
    }
    success_message {
      value
    }
    error_message {
      value
    }
  }
`

export const useFormtSectionData = (language: string, pageCodename: string, sectionCodename = '') => {
  const data = useStaticQuery(formSectionFragment)
  const formSectionData: KenticoFormSection = filterPageDataByLanguage(data.allKontentItemPage, pageCodename, sectionCodename, language)
  return new FormSection(formSectionData)
}